import { render } from "./unauthorized.vue?vue&type=template&id=ba0ebf6e"
import script from "./unauthorized.vue?vue&type=script&lang=js"
export * from "./unauthorized.vue?vue&type=script&lang=js"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__